import { render, staticRenderFns } from "./MessageNotifier.vue?vue&type=template&id=f8692c02&scoped=true&"
import script from "./MessageNotifier.vue?vue&type=script&lang=js&"
export * from "./MessageNotifier.vue?vue&type=script&lang=js&"
import style0 from "./MessageNotifier.vue?vue&type=style&index=0&id=f8692c02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8692c02",
  null
  
)

export default component.exports